import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, Leaf } from "lucide-react";
import { toast, Toaster } from "sonner";
import { useAuth } from "@/context/AppContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, pwd);
      toast.success("Connecté");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-bone flex items-center justify-center p-6">
      <Toaster richColors position="top-center" />
      <form onSubmit={submit} className="w-full max-w-sm bg-cream border border-sand p-10" data-testid="admin-login-form">
        <div className="flex items-center gap-2 mb-8">
          <span className="w-9 h-9 rounded-full bg-forest text-cream flex items-center justify-center">
            <Leaf className="w-4 h-4" />
          </span>
          <span className="font-display text-2xl text-forest">Espace admin</span>
        </div>
        <p className="label-eyebrow mb-2">Email</p>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border-b border-sand bg-transparent py-3 mb-6 text-forest focus:border-forest focus:outline-none"
          data-testid="login-email"
        />
        <p className="label-eyebrow mb-2">Mot de passe</p>
        <input
          type="password"
          required
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
          className="w-full border-b border-sand bg-transparent py-3 mb-8 text-forest focus:border-forest focus:outline-none"
          data-testid="login-password"
        />
        <button disabled={busy} type="submit" className="btn-primary w-full" data-testid="login-submit">
          <Lock className="w-4 h-4" /> {busy ? "Connexion..." : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
